export default __webpack_public_path__ + "static/media/game-examples.eb16301d.md";